/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ContemporaryLandingTextHeaderModule_contemporaryLandingHeader$ref: FragmentReference;
export type ContemporaryLandingTextHeaderModule_contemporaryLandingHeader = {|
  +text: ?string,
  +$refType: ContemporaryLandingTextHeaderModule_contemporaryLandingHeader$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ContemporaryLandingTextHeaderModule_contemporaryLandingHeader",
  "type": "ContemporaryLandingHeader",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "text",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '8e672d8cb57995f34e322f12cf68ea48';
module.exports = node;
